import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row, Tabs, Typography, Pagination } from "antd";
import { useQuery } from "react-query";

import "./index.scss";
import ProductDetail from "@components/ProductDetail";
import BitResults from "@components/BitResults";
import EmptyData from "@components/EmptyData";
import { getResultsProduct } from "@dataLayer/product";
import { getUserQuery } from "@dataLayer/user";

const { Title } = Typography;
const { TabPane } = Tabs;

const ProductOverview = ({ products, isLogin }) => {
  return (
    <>
      {products?.length > 0 && (
        <Row gutter={[0, 10]}>
          {products.map((product) => (
            <Col md={24} key={product.cp_id}>
              <div className="results-item">
                <Row
                  gutter={[
                    { xs: 30, sm: 30, md: 30, xl: 30, xxl: 30 },
                    0,
                  ]}
                >
                  <Col xs={24} md={24} lg={24} xl={15} xxl={17}>
                    <div className="results-item-product">
                      <ProductDetail
                        product={product}
                        isResultOverview={true}
                        isWinner={product.status !== 5}
                        isNoOneWinner={product.status === 5}
                        isLogin={isLogin}
                        isPotentialWinner={false}
                      />
                    </div>
                  </Col>

                  <Col xs={24} md={24} lg={24} xl={9} xxl={7}>
                    <BitResults product={product} />
                  </Col>
                </Row>
              </div>
            </Col>
          ))}
        </Row>
      )}

      {products?.length === 0 && <EmptyData />}
    </>
  );
};

const ResultsPage = () => {
  const { data: products } = useQuery(getResultsProduct());
  const { data: user } = useQuery(getUserQuery());

  const { t } = useTranslation();

  const [numProduct, setNumProduct] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = 5;

  useEffect(() => {
    document.title = t("title.results");
  }, [t]);

  // sort product theo cp_id giảm dần
  const sortedProducts = React.useMemo(() => {
    return [...(products || [])].sort((a, b) => b.cp_id - a.cp_id);
  }, [products]);

  useEffect(() => {
    setNumProduct(sortedProducts?.length || 0);
  }, [sortedProducts]);

  const callback = (key) => {
    setCurrentPage(1);

    if (key === "tab-have-winners") {
      setNumProduct(sortedProducts?.filter((p) => p.status !== 5).length);
    } else if (key === "tab-no-winners") {
      setNumProduct(sortedProducts?.filter((p) => p.status === 5).length);
    } else {
      setNumProduct(sortedProducts?.length);
    }
  };

  const paginatedProducts = sortedProducts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const paginatedWinnerProducts = sortedProducts
    .filter((p) => p.status !== 5)
    .slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const paginatedNoWinnerProducts = sortedProducts
    .filter((p) => p.status === 5)
    .slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div className="results-page">
      <div className="results-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <Tabs
              className="history-page-tabs"
              defaultActiveKey="tab-all"
              onTabClick={callback}
              tabBarExtraContent={{
                left: (
                  <Title level={2} className="results-page-title">
                    {t("results")}{" "}
                    <span className="number">{numProduct}</span>
                  </Title>
                ),
              }}
            >
              <TabPane tab={t("results_page.all")} key="tab-all">
                <ProductOverview
                  products={paginatedProducts}
                  isLogin={user}
                />

                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={sortedProducts.length}
                  onChange={(page) => setCurrentPage(page)}
                  style={{ marginTop: 20, textAlign: "center" }}
                />
              </TabPane>

              <TabPane
                tab={t("results_page.have_winner")}
                key="tab-have-winners"
              >
                <ProductOverview
                  products={paginatedWinnerProducts}
                  isLogin={user}
                />

                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={sortedProducts.filter((p) => p.status !== 5).length}
                  onChange={(page) => setCurrentPage(page)}
                  style={{ marginTop: 20, textAlign: "center" }}
                />
              </TabPane>

              <TabPane
                tab={t("results_page.no_winner")}
                key="tab-no-winners"
              >
                <ProductOverview
                  products={paginatedNoWinnerProducts}
                  isLogin={user}
                />

                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={sortedProducts.filter((p) => p.status === 5).length}
                  onChange={(page) => setCurrentPage(page)}
                  style={{ marginTop: 20, textAlign: "center" }}
                />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ResultsPage;
